import React from "react";
import logo from "../assets/sme-logo.png";
import { BiLogOut } from "react-icons/bi";
import { motion } from "framer-motion"; // import motion

const ValidatedModalRedemption = ({ data, handleLogout, markAsCollected }) => {
  return (
    <>
      <div className="p-3 flex w-full justify-between items-center">
        <img src={logo} alt="logo" className="w-[100px] h-auto object-contain" />
        <button
          className="bg-primary-color hover:bg-green-400 text-white text-lg font-bold py-2 px-4 rounded"
          onClick={handleLogout}
        >
          <BiLogOut />
        </button>
      </div>

      <div className="flex w-full justify-center items-center mt-8">
        <div className=" p-6 space-y-5 rounded-lg shadow-sm w-full max-w-md bg-white">
          <h2 className="text-2xl text-primary-color font-bold mb-4 ">
            Redemption Details 
          </h2>
          <p><strong>Name:</strong> {data.firstName} {data.lastName}</p>
          <p><strong>Reference:</strong> {data.reference}</p>

          <div className="mt-4">
            <p className="font-bold text-primary-color mb-2">Items to Redeem:</p>
            <ul className="list-disc space-y-5 list-inside text-gray-700">
              {data.items.map((item, index) => (
                <li key={index}>
                  {item.quantity} of {item.product} {item.size}
                </li>
              ))}
            </ul>
          </div>

          <p className="mt-4">
            <strong>Status:</strong> 
            {data.collected ? (
              <motion.span
                className="text-green-600 ml-2 flex items-center gap-2"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                ✅ Collected
              </motion.span>
            ) : (
              <span className="text-red-600 ml-2">Not Collected</span>
            )}
          </p>

          {/* If not collected, show button */}
          {!data.collected && (
            <button
              onClick={markAsCollected}
              className="mt-6 w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-lg font-bold"
            >
              Mark as Collected
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default ValidatedModalRedemption;
